import { Container } from "@/components/shared";
import FeedbackForm from "@/components/FeedbackForm";
import { Heart, Lightbulb, Rocket, Bug, Star } from "lucide-react";

const PILLARS = [
  { icon: Star, label: "Noter l'application" },
  { icon: Heart, label: "Donner son avis" },
  { icon: Lightbulb, label: "Proposer une idée" },
  { icon: Rocket, label: "Suggérer une fonctionnalité" },
  { icon: Bug, label: "Signaler un bug" },
];

export default function VoiceFeedback() {
  return (
    <Container>
      <div className="max-w-2xl mx-auto" data-testid="voice-feedback-page">
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 text-gold text-xs uppercase tracking-[0.2em] mb-3">
            <Heart size={14} /> Votre avis
          </div>
          <h1 className="font-display text-3xl sm:text-4xl font-light tracking-tight mb-3">
            Construisons BIZARRE AI <span className="gold-text">ensemble</span>
          </h1>
          <p className="text-white/55 text-sm sm:text-base">
            Votre voix façonne l'application. Chaque note, idée ou signalement est lu et nous aide à
            améliorer BIZARRE AI en continu.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-2 mb-9">
          {PILLARS.map((p) => {
            const Icon = p.icon;
            return (
              <span key={p.label} className="inline-flex items-center gap-1.5 rounded-full border border-white/10 bg-white/[0.04] px-3 py-1.5 text-xs text-white/70">
                <Icon size={13} className="text-gold" /> {p.label}
              </span>
            );
          })}
        </div>

        <div className="card-surface p-6 sm:p-8">
          <FeedbackForm defaultType="compliment" />
        </div>

        <p className="text-center text-white/30 text-xs mt-6">
          Merci de faire partie de l'aventure. 💛 Vos retours sont anonymisés dans nos statistiques.
        </p>
      </div>
    </Container>
  );
}
